<template>
  <AppInputField class="textarea">
    <label v-if="label">{{ label }}</label>
    <textarea
      v-bind="$attrs"
      v-on="{
        ...$listeners,
        input: updateValue,
      }"
      :value="value"
      class="app-textarea"
    ></textarea>
  </AppInputField>
</template>

<script>
// Utilities
// import { getComputedStyles } from 'Utils'
// Components
import AppInputField from 'Ui/AppInputField'

export default {
  name: 'AppTextArea',
  inheritAttrs: false,

  components: {
    AppInputField,
  },

  props: {
    label: {
      type: String,
      default: '',
    },

    autoHeight: {
      type: Boolean,
      default: false,
    },

    value: String,
  },

  methods: {
    updateValue(event) {
      this.$emit('input', event.target.value)
    },

    runAutoHeight() {
      if (!this.autoHeight) return
      const element = this.$el
      const setHeight = async () => {
        const textarea = element.firstElementChild
        // const offSet = parseInt(getComputedStyles(textarea, 'padding-bottom'))
        textarea.style.overflow = 'hidden'
        textarea.style.overflowWrap = 'break-word'
        textarea.style.height = '1px'
        textarea.style.height = `${textarea.scrollHeight}px`
      }

      setHeight()
    },
  },

  mounted() {
    this.runAutoHeight()
  },

  updated() {
    this.runAutoHeight()
  },
}
</script>

<style scoped>
.app-textarea {
  line-height: 24px;
  padding: 6px 12px 8px;
  height: 35px;
  resize: none;
  background-color: #fff;
  transition: none;
}

.app-textarea::placeholder {
  color: var(--c-secondary);
}
</style>
